import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios"; 
import Dropzone  from "react-dropzone";
import { LangContext } from "../LangContext.jsx";
class UploadInternalDossiers extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossiers:[],
            dossier_id:[],
            name:'',
            selectedCountry:1,
        };
    } 
    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
        $('#btnSubmit').removeClass("d-none");
    };
    handleDossierChange= (event) => {
        this.setState({ dossier_id: event.target.value });
    };
    handleChangeCountry = (event)=>{
        this.setState({ selectedCountry: event.target.value },function(){
            this.getDossiers()
        });
    }
    handleResponse = (responseData) => {  
    };
    async getDossiers(){
        const res = await axios.get('/api/providers/internal/dossiers/auth?country_id='+this.state.selectedCountry)
        this.setState({dossiers: res.data})
    }
    async componentDidMount() {
        await this.getDossiers(); 
    }
    render() {
        const { lang } = this.context; 
        return (
            <div className="d-flex flex-column-fluid">
            <div className="container">
            <div class="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                    <div>
                        <span class="flaticon2-warning mr-2 icon-3x"></span>
                    </div>
                    <div>
                        <h3>{lang.get('messages.nota')}</h3>
                        {lang.get('messages.los_expedientes_que_cuenten_con_documentos_con_validaciones_automaticas_solo_estan_disponibles_para_mexico')}  
                    </div>
                </div>
            <form onkeydown="return event.key != 'Enter';" method="POST" className="card card-custom gutter-b"
                action=""
                enctype="multipart/form-data"
                id="frm"
            > 
            <div className="card-body">
                <div className="row text-left">
                    <div className="col-sm-6 form-group fv-plugins-icon-container">
                        <label className="text-left">{lang.get('messages.pais')}</label>
                        <select id="countrySelect" value={this.state.selectedCountry}  name="country_id" className="form-control form-control-solid" onChange={this.handleChangeCountry}>
                                { this.props.usercountryid == 1 &&
                                    <option value='1'>{lang.get('messages.mexico')}</option>
                                }
                                <option value='2'>{lang.get('messages.colombia')}</option>
                                <option value='3'>{lang.get('messages.brasil')}</option>
                        </select> 
                    </div>  
                    <div className="col-sm-6 align-self-center form-group fv-plugins-icon-container">
                        <label className="text-left">{lang.get('messages.expedientes')}</label>
                        <select id="dossier_id" className="form-control form-control-solid"  value={this.state.dossier_id} onChange={this.handleDossierChange} >
                        {this.state.dossiers.map(dossier => (
                                            <option key={dossier.id} value={dossier.id}>
                                                {dossier.title}
                                            </option>
                                        ))}
                        </select>
                        <div className="fv-plugins-message-container"></div>
                    </div>
                </div>
                <div className="row text-left">
                    <div className="col-sm-6 form-group fv-plugins-icon-container">
                        <label className="text-left">  {lang.get('messages.identificador_de_carga')}</label>
                        <input id="name" type="text" required className="form-control form-control-solid" name="name" value={this.state.name}  // Vincula el valor al estado
                                        onChange={this.handleNameChange}    />
                        <div className="fv-plugins-message-container"></div>
                        <div id="error" className="d-none text-danger font-size-sm">{lang.get('messages.este_campo_es_obligatorio')}</div>
                    </div>
                    {this.state.selectedCountry == 1 && 
                    <div className="col-sm-6 align-self-center form-group fv-plugins-icon-container">
                        <label className="text-left">{lang.get('messages.documento_a_validar')} </label>
                        <input id="text" readonly type="text" placeholder="Constancia de Situación Fiscal" className="form-control form-control-solid" name="email" value=""/>
                        <div className="fv-plugins-message-container"></div>
                    </div> 
                    } 
                </div>
                {(this.state.selectedCountry == 2  ||  this.state.selectedCountry == 3) && 
                    <div className="col-sm-12 p-5 text-center form-group fv-plugins-icon-container">
                        {lang.get('messages.descarga_el')}
                        <a 
                        href={
                            this.state.selectedCountry == 2
                                ? "/assets/media/template/CargaExpedientesInternosColombia.xlsx"
                                : "/assets/media/template/CargaExpedientesInternosBrasil.xlsx"
                        }
                        > {lang.get('messages.ejemplo_de_plantilla')} </a>
                        {lang.get('messages.y_llenalo_con_los_datos_correspondientes_a_los_registros_que_vayas_a_necesitar')}.
                    </div> 
                }
                <div className="form-group row">
                    <div className="offset-md-2 col-md-8">
                        <div id="fileDropzone" className="dropzone dropzone-default">
                            <div className="dropzone-item" style={{ display: 'none' }}>
                                <div className="dropzone-file">
                                    <img src="/assets/img/file.svg"  style={{ width: '50px', margin: '10px 0px 5px 0px' }} />
                                    <div className="dropzone-filename" title="some_image_file_name.jpg">
                                        <span data-dz-name="">some_image_file_name.jpg</span>
                                        <strong>(
                                        <span data-dz-size="">340kb</span>)</strong>
                                    </div>
                                    <div className="dropzone-error" data-dz-errormessage=""></div>
                                </div>
                            </div>
                            <div className="dropzone-msg dz-message needsclick">
                                <h3 className="dropzone-msg-title">{lang.get('messages.suelta_el_archivo_aqui_o_haz_clic_para_subirlo')}.<br/>
                                <small> {lang.get('messages.solo_se_podra_cargar_un_solo_archivo_por_cada_carga_masiva_y_de_tipo')} &nbsp;
                                    {this.state.selectedCountry == 1 && 'ZIP'}
                                    {this.state.selectedCountry == 2 && 'XLS'}
                                    {this.state.selectedCountry == 3 && 'XLS'}
                                </small>
                                </h3>

                                <span className="dropzone-msg-desc">
                                    <bold>
                                    </bold>
                                    <br/>
                                </span>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <br/>
                <div className="text-center"> 
                    <a href="javascript:back()" className="btn btn-secondary">
                        {lang.get('messages.cancelar')}
                    </a> 
                    <button id="btnSubmit" type="button" className="btn btn-primary ml-4 d-none" >
                        {lang.get('messages.enviar')}
                    </button> 
                </div>
            </div>
        </form>
    </div>
</div>
        );
    }
}

export default UploadInternalDossiers;

if (document.getElementById('UploadInternalDossiers')) {
    ReactDOM.render(<UploadInternalDossiers />, document.getElementById('UploadInternalDossiers'));
}
